import Component from "@ember/component";
export default Component.extend({
  tagName: "h3",
  // icon name defined here so it can be easily overridden in theme components
  lockIcon: "lock",
});
